import service from '@/utils/request';

/**
 * @Summary 获取商户列表的数据
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /merchant/merchantList [post]
 * */
export var merchantList = function merchantList(data) {
  return service({
    url: '/merchant/merchantList',
    method: 'post',
    data: data
  });
};
export var editMerchantInfo = function editMerchantInfo(data) {
  return service({
    url: '/merchant/editMerchantInfo',
    method: 'post',
    data: data
  });
};
export var transferToWithdraw = function transferToWithdraw(data) {
  return service({
    url: '/merchant/transferToWithdraw',
    method: 'post',
    data: data
  });
};
export var checkCashFreeAmount = function checkCashFreeAmount() {
  return service({
    url: '/payment/checkCashFreeAmount',
    method: 'post'
  });
};
export var changeMerchantStatus = function changeMerchantStatus(data) {
  return service({
    url: '/merchant/changeMerchantStatus',
    method: 'post',
    data: data
  });
};
export var getMerchantChannelBalance = function getMerchantChannelBalance() {
  return service({
    url: '/merchant/getMerchantChannelBalance',
    method: 'post'
  });
};
export var changeMerchantWeightStatus = function changeMerchantWeightStatus(data) {
  return service({
    url: '/merchant/changeMerchantWeightStatus',
    method: 'post',
    data: data
  });
};
export var getMerchantAllList = function getMerchantAllList() {
  return service({
    url: '/merchant/merchantAllList',
    method: 'post'
  });
};